import React, { useState } from 'react'
import { Card, Container, Tab, Tabs } from 'react-bootstrap'
import { Form } from 'rsuite';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import { useNavigate } from 'react-router-dom';
import { GetRenewalInformationContent } from '../../../../Shared/InformationContent/LsiInformation';
import Information from '../../../../Shared/Card/Information';
import contactService from '../../../../../services/Internal/Renewal/LSI/contact.service';
import internalRenewalService from '../../../../../services/Internal/Renewal/LSI/lsiRenewal.service';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import Swal from 'sweetalert2';
import PersonalInformation from '../../../../Shared/Card/Contact/PersonalInformation';
import MailingAddress from '../../../../Shared/Card/Contact/MailingAddress';
import PublicAddress from '../../../../Shared/Card/Contact/PublicAddress';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import dayjs from 'dayjs';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import lsiRenewalService from '../../../../../services/Internal/Renewal/LSI/lsiRenewal.service';
import Issues from '../../../../Shared/Card/Issues';
import FormEntityInformation from '../../../Shared/FormEntityInformation';
import renewalService from '../../../../../services/Internal/Renewal/renewal.service';

function ContactInformationPage() {

    const push = useNavigate();
    const [hasLoaded, setHasLoaded] = useState(false);
    const renewalId = useSelector(x => x.currentApplicationId);
    const sectionId = 1;
    const routes = useSelector(x => x.currentRoutes);
    const [formModel, setFormModel] = useState({});
    const [tabPane, setTabPane] = useState("personalInformation")
    const [sectionData, setSectionData] = useState({});
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Land Surveyor Intern Renewal",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Contact Information"
        }
    );
    useEffect(() => {
        contactService.getContactInformation(renewalId).then((response) => {
            var data = response.data;

            setFormModel({
                ...data,
               dateOfBirth: data.dateOfBirth != null ? dayjs(data.dateOfBirth).format('MM/DD/YYYY') : null,
                altEmail: data.alternateEmailAddress?.contactEmailAddress,
                primaryEmail: data.primaryEmailAddress?.contactEmailAddress,
                cellPhoneNum: data.cellPhone?.contactPhoneNumber,
                workPhoneNum: data.workPhone?.contactPhoneNumber,
                homePhoneNum: data.homePhone?.contactPhoneNumber
            })
            internalRenewalService.lsiGetSection(renewalId, sectionId).then((response) => {
                setSectionData(response.data);
                setIsComplete(response.data.staffReviewComplete);
                renewalService.getIndividualRenewal(renewalId).then((data) => {
                    setIsUserEditable(data.data.status.id == 2)
                    entityService.getEntity(response.data.entityId).then((entity) => {
                        setEntityInfo(
                            {
                                ...entityInfo,
                                lolaNum: entity.data.lolaNumber,
                                entityName: entity.data.formattedName,
                                entityId: entity.data.entityId,
                                licenseNumber: data.data?.credential?.formattedLicenseNumber,
                                applicationDate: data.data?.dateSubmitted
                            })
                        setHasLoaded(true);
                    });
                });
            })
        })
    }, [])

    const formSubmit = (validation, event) => {
        submitData();
    }

    const submitData = (isForSubmit) => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            lsiRenewalService.lsiMarkSectionComplete(renewalId, sectionId, isComplete).then((data) => {
                push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
            })
        }
    }

    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Information content={GetRenewalInformationContent("contact")} />
                <br />

                <Card>
                    <Card.Body>
                        {hasLoaded ?
                            <Tabs style={{ float: 'right' }} activeKey={tabPane} transition={false} onSelect={(selected) => { setTabPane(selected) }}>
                                <Tab eventKey="personalInformation" title="Personal Information">
                                    <br />
                                    <br />
                                    <Form id="personalInformationForm" fluid formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit} >
                                        <PersonalInformation isNonUsBirthState={formModel.birthCountry?.country != 'United States'} isUserEditable={isUserEditable} isReadOnly={true} />
                                    </Form>
                                </Tab>
                                <Tab eventKey="mailingAddress" title="Mailing Address">
                                    <br />
                                    <br />
                                    <Form fluid
                                        formValue={formModel.mailingAddress}
                                        onChange={(value) => { setFormModel({ ...formModel, mailingAddress: { ...value } }) }}
                                        id="mailingAddressForm">
                                        <MailingAddress isUserEditable={isUserEditable} isReadOnly={true} boundValues={formModel.mailingAddress} contactInfoLink={"/individual/contactInformation"} />
                                    </Form>
                                </Tab>
                                <Tab eventKey="publicAddress" title="Public Address">
                                    <br />
                                    <br />
                                    <Form fluid
                                        formValue={formModel.publicAddress}
                                        onChange={(value) => { setFormModel({ ...formModel, publicAddress: { ...value } }) }}
                                        id="publicAddressForm">
                                        <PublicAddress isUserEditable={isUserEditable} isReadOnly={true} boundValues={formModel.publicAddress} contactInfoLink={"/individual/contactInformation"} />
                                    </Form>
                                </Tab>
                            </Tabs> : <LoadingSpinner />
                        }
                    </Card.Body>
                </Card>
                <br />
                {hasLoaded &&
                    <Issues isUserEditable={isUserEditable} isInternal={true} type={3} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                }
                <FormActionButtons
                    isUserEditable={isUserEditable}
                    isComplete={isComplete}
                    isCompleteCallback={setIsComplete}
                    showSectionComplete={true}
                    submitFormName="personalInformationForm"
                    backToSectionLink="/internal/lsiRenewal/sections" />
            </Container>
        </div>
    );
}
export default ContactInformationPage